import { buildStudentSettlementSummary } from './studentSettlementTotals';

const toCents = amount => (Number.isFinite(amount) ? Math.round(amount * 100) : null);

export default function summarizeSettlements(settlements) {
  const summary = {
    count: settlements.length,
    chargeCents: 0,
    approvedCents: 0,
    draftCents: 0,
    paymentCents: 0,
    dueCents: 0,
    incompleteBalanceCount: 0,
    incompleteChargeCount: 0,
    incompletePaymentCount: 0,
    discountCents: 0,
    unknownDiscountCount: 0,
  };

  settlements.forEach((settlement) => {
    const discountSummary = buildStudentSettlementSummary({
      ...settlement,
      snapshot: settlement.approved ? settlement.snapshot : (settlement.previewSnapshot || settlement.snapshot),
      monthlyChargeAmount: settlement.summaryMonthlyChargeAmount,
    });
    summary.discountCents += discountSummary.knownDiscountCents;
    summary.unknownDiscountCount += discountSummary.unknownHistoryCount > 0 ? 1 : 0;
    const charge = toCents(settlement.summaryMonthlyChargeAmount);
    const payment = toCents(settlement.paymentsInMonth);
    const balance = toCents(settlement.summaryClosingBalance);

    if (charge === null) {
      summary.incompleteChargeCount += 1;
    } else {
      summary.chargeCents += charge;
      summary[settlement.approved ? 'approvedCents' : 'draftCents'] += charge;
    }

    if (payment === null) {
      summary.incompletePaymentCount += 1;
    } else {
      summary.paymentCents += payment;
    }

    if (settlement.billingAssignmentPending || balance === null) {
      summary.incompleteBalanceCount += 1;
    } else {
      summary.dueCents += Math.max(0, -balance);
    }
  });

  return summary;
}
